import { Components, Theme } from "@mui/material";

declare module "@mui/material/Tooltip" {}

export const MuiTooltip: Components<Theme>["MuiTooltip"] = {
  styleOverrides: {
    tooltip: {
      fontWeight: 500,
      lineHeight: "140%",
      letterSpacing: "0.5px",
      padding: "0.25rem 0.5rem",
    },
  },
};
